/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { MessageComponent } from '../components/message/message.component';

@Injectable()
export class NotificationService {
  constructor(private snack: MatSnackBar) {}

  private msg = '';
  private type = '';
  private duration = 5000;
  private data: any;
  private messageRef: MatSnackBarRef<MessageComponent> | null = null;

  dispatch(
    notification: string,
    type: string,
    duration?: number,
    data?: any
  ): void {
    this.msg = notification;
    this.type = type;
    this.duration = duration ? duration : this.duration;
    this.data = data;

    this.messageRef = this.snack.openFromComponent(MessageComponent, {
      data: {
        msg: this.msg,
        type: this.type,
        data: this.data ? this.data : null,
      },
      duration: this.duration ? this.duration : 5000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: 'snack-panel',
    });
  }

  dispatchDelete(
    notification: string,
    action: string,
    duration?: number
  ): MatSnackBarRef<any> {
    return this.snack.open(notification, action, {
      duration: duration ? duration : 10000,
      horizontalPosition: 'left',
    });
  }

  closeMessage(): void {
    if (this.messageRef) {
      this.messageRef.dismiss();
    }
  }
}
